/**
 * Radio builder — verbatim from v1 (research/03 §11, §15.3; REQ-ELEM-2).
 * Preserves the stray apostrophe after the wrapper's conditionalTemplate;
 * first option always rendered checked.
 */
import { appState } from "../state/app-state";
import { getConditionalDisplay, getToolTipHtml, parsedName , getElementWidthClass, t , dirAttr } from "./base";

export function buildRadioElement(element: any): string {
  var conditionalDisplay = getConditionalDisplay(element);
  let toolTipHtml = getToolTipHtml(element, "div");

  var res =
    "<div class='element checkbox-element" + getElementWidthClass(element) + "' data-element='" +
    element.Identifier +
    "' " +
    conditionalDisplay.conditionalTemplate +
    "'><label style='color:" +
    appState.calculatorStyling.upperTextColor +
    "'" + dirAttr(element.Name) + ">" +
    t(element.Name) +
    toolTipHtml +
    "</label>";

  let radioIteration = 0;
  element.Options.forEach((option: any) => {
    let radioSelectedText = radioIteration === 0 ? "checked" : "";
    res +=
      "<input class='calc-prop radio' data-identifier='" +
      element.Identifier +
      "' type='radio' onchange='ChangeEvent(null)' data-val='" +
      option.value +
      "' value='" +
      option.label +
      "' name=\"properties[" +
      parsedName(element.Name) +
      ']" ' +
      radioSelectedText +
      " data-calcname='" +
      element.Name +
      "'/><span style='color:" +
      appState.calculatorStyling.upperTextColor +
      "'" + dirAttr(option.label) + ">" +
      t(option.label) +
      "</span>";
    radioIteration++;
  });

  res += "</div>";
  return res;
}
